import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { CgSpinner } from 'react-icons/cg';

import Modal from 'common-components/Modal';
import ClearableDropdown from 'common-components/ClearableDropdown';
import NumberInput from 'common-components/NumberInput';
import DatePickerCalander from 'common-components/DatePickerCalander';
import Button from 'common-components/Button';
import TextInput from 'common-components/TextInput';
import { FETCH_LIMIT } from '../../config';
import { dateFormatter, prepareCatForDropdown } from '../../utils';

import 'react-datepicker/dist/react-datepicker.css';
import './filter.style.css';


const Filter = ({
  type,
  header,
  eventName,
  priviledge,
  showFilter,
  setShowFilter,
  setData,
  dropDownCat,
  existingCategories
}) => {
  const [minScore, setMinScore] = useState(0);
  const [maxScore, setMaxScore] = useState(0);
  const [prevalenceInfo, setPrevalenceInfo] = useState(0);
  const [tag, setTag] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [category, setCategory] = useState('');
  const [inputCatList, setInputCatList] = useState(null)
  const [limit, setLimit] = useState(5);

  const onFormSubmit = e => {
    e.preventDefault();
    applyFilter();
  }

  useEffect(() => {
    if (existingCategories) {
      let catList = prepareCatForDropdown(existingCategories);
      setInputCatList(catList);
    };
  }, [existingCategories]);

  const onTagChange = (event, result) => {
    const { value } = result || event.target;
    setTag(value);
  };

  const onLimitChange = (event, result) => {
    const { value } = result || event.target;
    setLimit(value);
  };

  const onCategoryChange = (event, result) => {
    const { value } = result || event.target;
    setCategory(value);
  };

  const applyFilter = () => {
    let min;
    let max;
    let pre_info;
    let from_date;
    let to_date;

    min = (minScore == 0) ? '' : minScore.toString();
    max = (maxScore == 0) ? '' : maxScore.toString();
    pre_info = (prevalenceInfo == 0) ? '' : prevalenceInfo.toString();
    from_date = (typeof startDate != 'string') ? dateFormatter(startDate.toLocaleDateString()) : '';
    to_date = (typeof endDate != 'string') ? dateFormatter(endDate.toLocaleDateString()) : '';

    setData({
      'limit': limit.toString(),
      'min_score': min,
      'max_score': max,
      'category': category,
      'from': from_date,
      'to': to_date,
      'tag': tag,
      'prevalence_info': pre_info
    });

    setShowFilter(false);
  };

  const filterContent = () => {
    return (
      <>
        <div className='filter-data'>
          <div className='header'>{header}</div>
          <form className='form-wrap' onSubmit={onFormSubmit}>
            {type === 'FETCH_FILTER' && (
              <div className='limit-dropdown'>
                <ClearableDropdown
                  placeHolder="Select limit.."
                  header="Fetch Count"
                  changeHandler={onLimitChange}
                  inputOptions={FETCH_LIMIT}
                  selectedValue={limit}
                  clearable={false}
                />
              </div>
            )}
            <div className='numbered-input-container'>
              <div className='min-score-input'>
                <NumberInput
                  header='Min Score'
                  count={minScore}
                  setCount={setMinScore}
                />
              </div>
              <div className='max-score-input'>
                <NumberInput
                  header='Max Score'
                  count={maxScore}
                  setCount={setMaxScore}
                />
              </div>
              <div className='prevalence-info-input'>
                <NumberInput
                  header='Prevalence Info'
                  count={prevalenceInfo}
                  setCount={setPrevalenceInfo}
                  disabled={true}
                />
              </div>
            </div>
            <div className={`category-dropdown${!dropDownCat ? '' : '-loaded'}`}>
              <ClearableDropdown
                placeHolder="Select category.."
                header="Category"
                clearable={true}
                changeHandler={onCategoryChange}
                inputOptions={dropDownCat}
                selectedValue={category}
              />
              {!dropDownCat && (
                <span className='spinner'>
                  <CgSpinner className='spin' />
                </span>)}
            </div>
            <div className='tag-input'>
              <TextInput
                placeHolder="Enter tag.."
                header="Tag"
                setText={setTag}
                inputText={tag}
                disabled={false}
              />
            </div>
            <div className='calander-container'>
              <DatePickerCalander
                header="From Date"
                selectedDate={startDate}
                changeHandler={date => setStartDate(date)}
                maxDate={endDate}
              />
              <DatePickerCalander
                header="To Date"
                selectedDate={endDate}
                changeHandler={date => setEndDate(date)}
                maxDate={new Date()}
                minDate={startDate}
              />
            </div>
            <Button
              children={eventName}
              onClick={applyFilter}
              type="submit"
              disabled={(priviledge.is_admin || priviledge.is_reviewer) ? false : true}
            />
          </form>
        </div>
      </>
    )
  };

  return (
    <div>
      <Modal
        showModal={showFilter}
        setShowModal={setShowFilter}
        content={filterContent()} />
    </div>
  )
};

const mapStateToProps = ({
  authentication: { priviledge },
  categories: { existingCategories } }) => ({
    priviledge,
    existingCategories
  });

export default connect(mapStateToProps)(Filter);